import React, { useEffect, useState } from "react";
import { Container, Button, Box } from "@mui/material";
import FormField from "../FormComponent/FormField/FormField";
import styles from './practitioner.module.css'
import { useForm } from 'react-hook-form';
import ImageUploadModal from "../../pages/Onboarding/ImageUploadModal";
import { axiosProxyInstance } from "../../utils/request";
import cogoToast from "cogo-toast";

const Business = ({ sectionData, details }) => {
    const [src, setSrc] = useState(null);
    const [open, setOpen] = useState(false);
    const [currentField, setCurrentField] = useState(null);
    const currentUserId = localStorage.getItem("LPCurrentUserId");

    const form = useForm({
        mode: "onBlur",
    });
    const { register, handleSubmit, control, formState: { errors }, reset } = form;
    const allFields = sectionData.fields;

    const clinicLogoField = allFields.find(field => field.id === "clinicLogo");

    const handleLinkButtonClick = (field) => {
        if (field.action === "handleImageChange") {
            setCurrentField(field);
            setSrc(field.src || null);
            setOpen(true);
        }
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleImageSave = (croppedImageUrl) => {
        if (currentField) {
            currentField.src = croppedImageUrl;
        }
        setSrc(croppedImageUrl);
        setOpen(false);
    };
    useEffect(() => {
        if (details) {
            clinicLogoField.src = details?.data?.logo;
            reset({
                clinicLogo: details?.data?.logo,
            });
        }
    }, [details, reset]);

    const onSubmit = async (data) => {
        const payload = {
            btn_submit: true,
            listings: [
                {
                    listing_id: details?.ID,
                    title: details?.post_title,
                    address_1: details?.data?.address_1,
                    postcode: details?.data?.postcode,
                    telephone_1: details?.data?.phone?.raw,
                    specialization: (Object.values(details.data.services || {})),
                    treatments: Object.values(details.data.treatments || {}),
                    logo: src,
                    provideruid: currentUserId,
                    uid: currentUserId
                }
            ]
        };
        try {
            const res = await axiosProxyInstance.post('/signup/2/', payload);
            cogoToast.success("Business Logo Updated Successfully!");
        } catch (err) {
            console.error("Submission failed:", err);
        }
    }
    return (
        <Box>
            <form onSubmit={handleSubmit(onSubmit)}>

                <Box className='margin-top-15'>
                    <Box style={{ flex: "1" }}>
                        <FormField
                            field={clinicLogoField}
                            register={register}
                            control={control}
                            errors={errors}
                            onLinkButtonClick={(clickedField) =>
                                handleLinkButtonClick(clickedField)
                            }
                        />
                        <Box className={styles.submitButtonContainer}>
                            <Button
                                className={styles.primaryButton}
                                size="large"
                                type="submit"
                            >
                                Save Changes
                            </Button>
                            <Button
                                className={styles.secondaryButton}
                                size="large"
                                type="submit"
                            >
                                Cancel
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </form>
            <ImageUploadModal open={open} onClose={handleClose} src={src} setSrc={setSrc} handleImageSave={handleImageSave} />
        </Box>

    )
}
export default Business